export {default} from './PeopleReportDataRenderer.connect';
